import "./bootstrap";
// Supports weights 300-800
// import "@fontsource-variable/open-sans";

// try {
//     // window.Popper = require('popper.js').default;
//     // window.$ = window.jQuery = require('jquery');
//     // require('bootstrap/dist/js/bootstrap.bundle');
//     // require('popper.js/dist/popper.min.js');
//     // require('bootstrap/js/dist/alert.js');
//     require('bootstrap/js/dist/button.js');
//     require('bootstrap/js/dist/collapse.js');
//     // require('bootstrap/js/dist/dropdown.js');
//     // require('bootstrap/js/dist/modal.js');
//     // require('bootstrap/js/dist/tab.js');
//     require('bootstrap/js/dist/toast.js');
//     // require('bootstrap/js/dist/tooltip.js');
//     // require('bootstrap/js/dist/util.js');
//     // require('lazyload/lazyload');

//     // require('bootstrap');
// } catch (e) {}


document.addEventListener('DOMContentLoaded', function() {
     // Check if already verified
    if (localStorage.getItem("ageVerified") === "true") {
        document.getElementById("ageModal").classList.add("d-none");
        return;
    }else {
        document.getElementById("ageModal").classList.remove("d-none");
    }

    const ageYes = document.getElementById("ageYes");
    const ageNo  = document.getElementById("ageNo");

    // YES – allow
    ageYes.addEventListener("click", function() {
        localStorage.setItem("ageVerified", "true");
        document.getElementById("ageModal").style.display = "none";
    });

    // NO – redirect
    ageNo.addEventListener("click", function() {
        window.location.href = "https://google.com";
    });
});